export default __webpack_public_path__ + "static/media/program-unlink-project.88db86c4.svg";